import React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Home from "./components/home";
import { useTheme } from "./hooks/useTheme";

const palettesByMode = {
  light: {
    mode: 'light',
    primary: {
      main: '#1a1f36',
    },
    secondary: {
      light: '#5b7fff',
      main: '#3d5afe',
      dark: '#2a3eb1',
      contrastText: '#ffffff',
    },
    background: {
      default: '#f4f5f7',
      paper: '#ffffff',
    },
    text: {
      primary: '#1a1f36',
      secondary: '#6b7280',
    },
  },
  dark: {
    mode: 'dark',
    primary: {
      main: '#c5cae9',
    },
    secondary: {
      light: '#8ba4ff',
      main: '#5b7fff',
      dark: '#3d5afe',
      contrastText: '#0b1220',
    },
    background: {
      default: '#14161a',
      paper: '#1b1e24',
    },
    text: {
      primary: '#e6e8eb',
      secondary: '#9aa1ac',
    },
  },
};

function getTheme(mode) {
  return createTheme({
    palette: palettesByMode[mode],
    shape: {
      borderRadius: 10,
    },
    typography: {
      fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      h6: {
        fontWeight: 600,
        letterSpacing: 0.2,
      },
      button: {
        fontWeight: 600,
        textTransform: 'none',
      },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: 8,
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundImage: 'none',
          },
          elevation1: {
            boxShadow: mode === 'dark'
              ? '0 1px 3px rgba(0,0,0,0.4), 0 1px 2px rgba(0,0,0,0.3)'
              : '0 1px 3px rgba(16,24,40,0.08), 0 1px 2px rgba(16,24,40,0.04)',
          },
        },
      },
      MuiTabs: {
        styleOverrides: {
          root: {
            minHeight: 48,
          },
        },
      },
      MuiTab: {
        styleOverrides: {
          root: {
            fontWeight: 500,
            minHeight: 48,
          },
        },
      },
    },
  });
}

function App() {
  const [mode, toggleTheme] = useTheme();
  const theme = React.useMemo(() => getTheme(mode), [mode]);

  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        <Home theme={mode} onToggleTheme={toggleTheme} />
      </div>
    </ThemeProvider>
  );
}

export default App;
